import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcessProgress } from './ProcessProgress';
import { ProgressService } from './progress.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {

  @ViewChild('progressDiv') progressDiv: ElementRef;
  processProgress: ProcessProgress;
  modalReference: any;

  constructor(
    private progress: ProgressService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.progress.getSubject().subscribe(progressProcess => {
      if (progressProcess.action === 'start') {
        this.start(progressProcess);
      } else if (progressProcess.action === 'stop') {
        this.stop();
      } else {
        this.update(progressProcess);
      }
    });
  }

  start(processProgress: ProcessProgress): void {
    this.processProgress = processProgress;
    this.modalReference = this.modalService.open(
      this.progressDiv,
      {
        centered: true,
        backdrop: 'static',
        keyboard: false
      }
    );
  }

  update(processProgress: ProcessProgress): void {
    this.processProgress = processProgress;
  }

  stop(): void {
    this.modalReference.close();
  }

}
